import React, { useState } from "react";

import DashboardIcon from "../../assets/images/dashboard_icon.svg";
import CampaignManagerIcon from "../../assets/images/campaign_manager_icon.svg";
import UsermanagementIcon from "../../assets/images/usermanagement_icon.svg";
import AdminIcon from "../../assets/images/admin_icon.svg";
import UserIcon from "../../assets/images/user_icon.svg";
import brandmanager from "../../assets/images/brand_manager_icon.svg";
import DownarrowIcon from "../../assets/images/down_arrow.svg";
import CustomerIcon from "../../assets/images/customer_icon.svg";
import VoucherIcon from "../../assets/images/voucher_icon.svg";
import CardtemplateIcon from "../../assets/images/card_template_icon.svg";
import FinancialStatementIcon from "../../assets/images/financialStatement_icon.svg";
import MembershipIcon from "../../assets/images/membership_icon.svg";
import ReportIcon from "../../assets/images/report_icon.svg";
import TransactionsIcon from "../../assets/images/transactions_icon.svg";
import smallkrtipayLogo from "../../assets/images/smallkrtipay_logo.svg";
import MerchantCategoryIcon from "../../assets/images/merchantCategory_icon.svg";
import GlobalSettingIcon from "../../assets/images/globalSetting_icon.svg";
import CountryIcon from "../../assets/images/country_icon.svg";
import DocumentIcon from "../../assets/images/documentTypeIconfnl.svg";
import SupportIcon from "../../assets/images/supportQuery_icon.svg";
import  oneEyeLogo  from "../../assets/images/applogo.webp";



import { selectCurrentUser } from "../../store/user/user.selector";
import { useSelector } from "react-redux";

import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ toggle }) => {
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUser);
  const userType = user?.userDetail?.userType;
  const location = useLocation();
  const { pathname } = location;

  

  const [userManagement, setUserManagement] = useState(false);
  const [setting, setsetting] = useState(false);

  return (
    <div className="sidebar_wrapper ">
      <div className="adminLogo">
        {/* <img src={logo} alt="logo" /> */}
        {toggle ? (
          <img src={oneEyeLogo} alt="smallLogo" />
        ) : (
          <img src={oneEyeLogo} alt="logo" />
        )}

        {/* <h1 className="fontSize24 fontWeight600 whiteClr_text  mb_24">Krti</h1> */}
      </div>
      <ul>
      <li>
          <button
            className={`${pathname?.includes("dashboard") && "active"}`}
            onClick={() => navigate(`/${userType}/dashboard`)}
          >
            <img src={DashboardIcon} alt="DashboardIcon" />
            <span>Dashboard</span>
          </button>
        </li>
      <li>
          <button
            className={`${pathname?.includes("transaction") && "active"}`}
            onClick={() => navigate(`/${userType}/transaction`)}
          >
            <img src={TransactionsIcon} alt="TransactionsIcon" />
            <span>Transactions </span>
          </button>
        </li>
        <li>
          <button
            className={`${pathname?.includes("transaction-report") && "active"}`}
            onClick={() => navigate(`/${userType}/transaction-report`)}
          >
            <img src={TransactionsIcon} alt="TransactionsIcon" />
            <span>Transactions Report </span>
          </button>
        </li>
        <li>
          <button
            className={`${pathname?.includes("destination-management") && "active"}`}
            onClick={() => navigate(`/${userType}/destination-management`)}
          >
            <img src={SupportIcon} alt="SupportIcon" />
            <span>Destination Management </span>
          </button>
        </li>
        <li>
          <button
            className={`${pathname?.includes("project-management") && "active"}`}
            onClick={() => navigate(`/${userType}/project-management`)}
          >
            <img src={SupportIcon} alt="SupportIcon" />
            <span>Project Management </span>
          </button>
        </li>
        <li>
          <button
            className={`${pathname?.includes("location-management") && "active"}`}
            onClick={() => navigate(`/${userType}/location-management`)}
          >
            <img src={SupportIcon} alt="SupportIcon" />
            <span>Location Management </span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
